import styled from 'styled-components';
import { gridContainer, getSpace, px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationStage = styled.section`
  padding: ${getSpace('m')} 0;
  position: relative;

  ${mq('m')} {
    padding: ${getSpace('xl')} 0;
  }
  
  .stage__breadcrumb {
    top: 0;
  }
  .stage__grid {
    ${gridContainer()}
    gap: ${px2rem('40px')};

    ${mq('m')} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .stage__image {
      .stage__image-title {
        font-size: ${px2rem('34px')};
      }
      ${mq('m')} {
        order: 2;
      }
    }
    .stage__intro {
      ${mq('m')} {
        order: 1;
      }
      
      h1 {
        font-size: ${px2rem('30px')};
        
        ${mq('m')} {
          font-size: ${px2rem('36px')};
        }
        ${mq('l')} {
          font-size: ${px2rem('50px')};
        }
      }
      .stage__introduction {
        margin: ${getSpace('m')} 0;
      }
    }
  }
  .stage__tag-line {
    margin-bottom: ${getSpace('s')};
    align-items: center;
    gap: ${px2rem('16px')};
    flex-wrap: wrap;
    
    &.hidden-desktop {
      display: flex;

      ${mq('m')} {
        display: none;
      }
    }
    &.hidden-mobile {
      display: none;

      ${mq('m')} {
        display: flex;
      }
    }
  }
  .stage__tag {
    .filter-tag {
      padding: ${px2rem('3px')} ${getSpace('xs')};

      .filter-tag__title {
        font-size: ${px2rem('16px')};
      }
    }
  }
`;

export default StyledEducationStage;
